"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const kendo_react_common_1 = require("@progress/kendo-react-common");
const kendo_react_dropdowns_1 = require("@progress/kendo-react-dropdowns");
const input_style_1 = __importDefault(require("./input.style"));
const Dropdown = (_a) => {
    var { label, errorMessage, theme } = _a, props = __rest(_a, ["label", "errorMessage", "theme"]);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [label && (0, jsx_runtime_1.jsx)("label", Object.assign({ "data-testid": 'label-dropdown-testid', style: input_style_1.default.label(theme) }, { children: label })), (0, jsx_runtime_1.jsxs)(kendo_react_common_1.ZIndexContext.Provider, Object.assign({ value: 99999 }, { children: [(0, jsx_runtime_1.jsx)(kendo_react_dropdowns_1.DropDownList, Object.assign({}, props)), !props.valid && ((0, jsx_runtime_1.jsx)("small", Object.assign({ hidden: props.valid, className: 'error-label', "data-testid": 'error-dropdown-testid' }, { children: errorMessage })))] }))] }));
};
exports.default = Dropdown;
